import {Component} from '@angular/core';
import {FamilyFullTableConfig, FamilyTranslations} from "../../../frame-entity-config/family";
import {FamilyModel} from "../../models/family.model";
import {FrameEntityListComponent, SnackBarService} from "@overflo1/frame-frontend";
import {MachineService} from "../../../machine/services/machine/machine.service";
import {Router} from "@angular/router";
import {FullTableActionModel} from "@overflo1/full-table";
import {FamilyService} from "../../services/family.service";
import {FamilyCustomActionEnum} from "../enums/family-custom-action.enum";


@Component({
  selector: 'app-family-list',
  standalone: true,
  imports: [
    FrameEntityListComponent,
  ],
  templateUrl: './family-list.component.html',
  styleUrl: './family-list.component.scss'
})
export class FamilyListComponent {
  entityConfig;
  familiesCounts: Record<string, number>;
  tableActions: FullTableActionModel[] = [
    {
      icon: 'toggle_on',
      type: FamilyCustomActionEnum.enable,
      filter: (element) => !element.enabled,
    },
    {
      icon: 'toggle_off',
      type: FamilyCustomActionEnum.disable,
      filter: (element) => element.enabled,
    }
  ];
  showDefaultActionsConditions = {delete: (el) => false}

  constructor(
    private machineService: MachineService,
    private router: Router,
    private familyService: FamilyService,
    private snackBarService: SnackBarService,
  ) {
    const config: any = FamilyFullTableConfig;
    this.getFamiliesCounts()
    this.addMachinesCountsColumn(config)
    this.addMachinesLinkColumn(config)
    this.entityConfig = config;
  }

  async goToCustomAction(event: FullTableActionModel) {
    switch (event.type) {
      case FamilyCustomActionEnum.enable:
      case FamilyCustomActionEnum.disable:
        await this.toggleFamilyEnableValue(event.element.id)
        break;
      case 'click':
        break;
      default:
        this.snackBarService.openErrorSnackBar(`Tipo evento non gestito: ${event.type}`,);
    }
  }

  async toggleFamilyEnableValue(id: number) {
    await this.familyService.toggleFamilyEnableValue(id)
    window.location.reload()
  }

  addMachinesLinkColumn(config) {
    config.allowedColumns.push('goToMachineTable');
    config.columns.push({
      def: "goToMachineTable",
      name: FamilyTranslations.fields.goToMachineTable,
      value: (element: FamilyModel) => "Visualizza",
      click: (element: FamilyModel) => {
        const filters = {
          'family.name__operation': '==',
          'family.name__value': element.name,
        };
        this.router.navigate(['frame/entity/machine'], {queryParams: filters});
      }
    });
  }

  async addMachinesCountsColumn(config: any) {
    config.allowedColumns.push('machineCount');
    config.columns.push({
      def: "machineCount",
      name: FamilyTranslations.fields.machineCount,
      value: (element: FamilyModel) => this.familiesCounts[element.name] ?? 0,
    });
  }

  async getFamiliesCounts() {
    const data: { count: number, family_name: string }[] = await this.machineService.getMachineFamilyCounters()
    this.familiesCounts = Object.fromEntries(data.map(el => [el.family_name, el.count]))
  }

}
